// Core
import { Link, Route, Switch, Redirect, useRouteMatch, useLocation } from 'react-router-dom';

// Chakra imports
import { 
  Box, 
  Flex, 
  Text,
  useColorModeValue
} from '@chakra-ui/react';

// Components
import MessageList from './Messages.js';
import MessageMatch from './Message.js';

function Messages(props) {
  const { path, url } = useRouteMatch();

  const location = useLocation();
  const isActive = (path) => location.pathname.includes(path);

  const textColor = useColorModeValue('blue.800', 'white');

  return (
    <Switch>
      <Route path={`${path}/:id`} render={() => <MessageMatch object={props.object} />} />
      <Route path={`${path}`} render={() => <MessageList object={props.object} />} />
      <Redirect from={`${path}*`} to={`${path}`} />
    </Switch>
  );
}

export default Messages;